import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Careers from "./Careers";

function Career() {
  return (
    <div>
      <Header />
      <Careers />
      <Footer />
    </div>
  );
}

export default Career;
